export default {
  main: {
    title: 'संस्करण सत्यापन',
    language: 'हिंदी',
    intro:
      'संस्करण सत्यापन का कार्य MD5 या SHA256 हैश वैल्यू को संस्करणों के बीच मिलाकर किया जाता है। कृपया याद रखें कि ठगी से बचने के लिए आधिकारिक स्रोतों के माध्यम से TokenPocket वॉलेट डाउनलोड करें। संस्करण के MD5 या SHA256 हैश वैल्यू कैसे प्राप्त करने के लिए निर्देशिका के लिए कृपया ',
    tutorial: 'ट्यूटोरियल देखें >',
    system: 'ओएस',
    android: 'एंड्रॉइड',
    ios: 'आईओएस',
    version: 'संस्करण',
    allVersion: 'सभी',
    appChannel: 'ऐप चैनल',
    developer: 'डेवलपर',
    allChannel: 'सभी',
    md5: 'एमडी5',
    sha256: 'एसएचए256',
    log: 'संस्करण लॉग',
    check: 'विवरण',
    versionLog: 'संस्करण लॉग',
    confirm: 'पुष्टि करें',
    aboutIOS: 'आईओएस संस्करण के बारे में',
    IOSDesc:
      'आईओएस संस्करण के लिए, हम केवल App Store पर हमारा ऐप प्रदान करते हैं। केवल App Store से डाउनलोड की गई ऐप्स को सही ढंग से स्थापित किया जा सकता है। इसलिए, Apple उपयोगकर्ताओं को सुनिश्चित करें कि वे सिर्फ़ App Store को एकमात्र डाउनलोड चैनल के रूप में प्रमाणित करें।',
    IOSDesc_2:
      'App Store से 8 अक्टूबर 2022 से पहले डाउनलोड की गई संस्करण के डेवलपर हैं TOKENPOCKET FOUNDATION LTD, जो TokenPocket द्वारा विकसित एक प्रारंभिक संस्करण है। यह एक वैध वॉलेट है जो सामान्यतः उपयोग किया जा सकता है, लेकिन अपडेट सेवा अस्थायी रूप से निलंबित की जाएगी।',
    aboutAndroid: 'Android संस्करण के बारे में ',
    androidDesc: 'वर्तमान में TokenPocket Android डाउनलोड चैनल शामिल हैं: आधिकारिक वेबसाइट, Google Play स्टोर, Samsung ऐप स्टोर, Huawei ऐप गैलरी, OPPO ऐप स्टोर, Vivo ऐप स्टोर। कुछ एप्लिकेशन स्टोर में डाउनलोड प्रक्रिया के दौरान APK स्थापना पैकेज प्राप्त नहीं किया जा सकता है, इसलिए MD5 या SHA256 गणना सत्यापन नहीं कर सकते। इसलिए, डाउनलोड करते समय, कृपया विकासकर्ता जानकारी की सत्यापन करें और नीचे दिए गए को संदर्भ में लें!',
    IOSAppName: 'ऐप्लिकेशन का नाम:',
    TPWallet: 'टीपी वॉलेट',
    AppIcon: 'ऐप्लिकेशन आइकन:',
    AppDeveloper: 'डेवलपर:',
    downloadLink: 'डाउनलोड लिंक:',
    copied: 'कॉपी किया गया!',
    versionVerification: 'Version Verification',
  },
  follow: {
    title: 'हमारे पर का पालन करें',
    desc1: 'TokenPocket कर्मचारी आपको निजी संदेश नहीं भेजेंगे!',
    desc2:
      'सावधानी! आप टोकनपॉकेट समुदाय में प्रवेश कर रहे हैं, हो सकता है कि कोई व्यक्ति आपको निजी संदेश भेजने के लिए प्रतिरूपित कर रहा हो! कृपया ध्यान रखें कि निजी संदेश भेजने वाला कोई भी व्यक्ति स्कैमर हो सकता है! हम आपसे पहले कभी संपर्क नहीं करेंगे!',
    desc3: 'समझे, दर्ज करें',
  },
  COMMON: {
    LAYOUT: {
      features: 'विशेषताएँ',
      products: 'उत्पादों',
      buyCryptoFooter: 'खरीदना',
      mobileWallet: 'मोबाइल वॉलेट',
      mobileWalletDesc: 'ब्लॉकचेन पर क्रिप्टो और DeFi मोबाइल वॉलेट।',
      hardwareWallet: 'एक्सटेंशन वॉलेट',
      hardwareWalletDesc: 'आपके कंप्यूटर पर एक बेहतर वॉलेट.',
      extensionWallet: 'हार्डवेयर वॉलेट',
      extensionWalletDesc: 'अपनी संपत्तियों की सुरक्षा के लिए अपना KeyPal प्राप्त करें।',
      desktop: 'Desktop Wallet',
      fiveDegrees: '5Degrees',
      versionVerification: 'संस्करण सत्यापन',
      versionVerificationDesc: 'अपना वॉलेट सत्यापित करें.',
      approvalDetector: 'अनुमोदन डिटेक्टर',
      approvalDetectorDesc: 'अपने स्वीकृत टोकन देखें और अस्वीकृत करें।',
      tokenSecurity: 'टोकन सुरक्षा',
      tokenSecurityDesc: 'सत्यापित करें कि टोकन उसके अनुबंध पते से सुरक्षित है या नहीं।',
      keyGenerator: 'कुंजी जनरेटर',
      keyGeneratorDesc: 'विभिन्न नेटवर्कों के लिए बेतरतीब ढंग से सार्वजनिक और निजी कुंजी उत्पन्न करें।',
      tokenProfile: 'टोकन प्रोफ़ाइल',
      tokenProfileDesc: 'टोकन के बारे में सारी जानकारी जानें.',
      tokenClaim: 'सांकेतिक दावा',
      tokenClaimDesc: 'अपने एयरड्रॉप का दावा करें.',
      easyInscription: 'आसान शिलालेख',
      easyInscriptionDesc: 'एक सुरक्षित शिलालेख उपकरण.',
      nostrAssetsBatchSender: 'NostrAssets  बैचसेंडर',
      nostrAssetsBatchSenderDesc: 'NostrAssets के लिए एक बैच भेजने वाला उपकरण।',
      BATCH_SENDER: 'बैचसेंडर',
      BATCH_SENDER_DESC: 'एक साथ अनेक प्राप्तकर्ताओं को टोकन भेजें।',
  
      trade: 'व्यापार',
      swap: 'बदलना',
      swapDesc: 'सर्वोत्तम कीमतों के साथ व्यापार करें।',
      bridge: 'ब्रिज',
      bridgeDesc: 'परिसंपत्तियों को एक श्रृंखला से दूसरी श्रृंखला में निर्बाध रूप से स्थानांतरित करें।',
      buyCrypto: 'खरीदना',
      buyCryptoDesc: 'अपने क्रेडिट कार्ड से क्रिप्टोकरेंसी खरीदें।',
      market: 'बाज़ार',
      marketDesc: 'हॉट टोकन खोजने के लिए वास्तविक समय की अंतर्दृष्टि।',
  
      information: 'जानकारी',
      blockchainGuide: 'ब्लॉकचेन गाइड',
      tronWallet: 'ट्रॉन गाइड',
      iostWallet: 'IOST गाइड',
      tpMan: 'TP Man',
  
      developers: 'डेवलपर्स',
      github: 'Github (TP-Lab)',
      devCenter: 'डेवलपर केंद्र',
      developersDesc: 'टोकनपॉकेट डेवलपर दस्तावेज़ीकरण।',
      subToken: 'टोकन जमा करें',
      subTokenDesc: 'अपना टोकन जमा करें.',
      subDApp: 'DApp जमा करें',
      subDAppDesc: 'अपना DApp जमा करें, और ऑडिट के बाद इसे दिखाएं।',
      subNFT: 'NFT जमा करें',
      subNFTDesc: 'अपना NFT और कला जमा करें।',
      subChain: 'चेन जमा करें',
      subChainDesc: 'अपना ब्लॉकचेन सबमिट करें.',
      bugBounty: 'Bug Bounty',
  
      tools: 'औजार',
  
      build: 'निर्माण',
  
      learn: 'सीखना',
  
      explorer: 'अन्वेषक',
  
      company: 'कंपनी',
      about: 'के बारे में',
      careers: 'करियर',
      pressKit: 'ब्रांड किट',
      swagShop: 'स्वैग की दुकान',
  
      support: 'सहायता',
      helpCenter: 'सहायता केंद्र',
      helpCenterDesc: 'उत्तर और सहायता के लिए आपके संसाधन।',
      contactUs: 'संपर्क करें',
      contactUsDesc: 'अपने सुझाव साझा करें और कोई भी प्रश्न पूछें।',
      forum: 'फोरम',
      forumDesc: 'समुदाय के सदस्यों के साथ अपनी बातचीत का आनंद लें।',
  
      legal: 'वैध',
      privacyPolicy: 'गोपनीयता नीति',
      terms: 'उपयोग की शर्तें',
  
      toHome: 'होम',
      defiWallet: 'DeFi वॉलेट',
      ETHWallet: 'Ethereum वॉलेट',
      ethWallet: 'ETH वॉलेट',

      dappStore: 'डीएप स्टोर'
    }
  }
};
